
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./Ledger": () => {
return Promise.all(/*  | __federation_expose_Ledger */ [__webpack_require__.e("168"), __webpack_require__.e("34"), __webpack_require__.e("823"), __webpack_require__.e("560")]).then(() => (() => (__webpack_require__(6693))));
},
"./InsuranceStats": () => {
return Promise.all(/*  | __federation_expose_InsuranceStats */ [__webpack_require__.e("168"), __webpack_require__.e("34"), __webpack_require__.e("286"), __webpack_require__.e("318")]).then(() => (() => (__webpack_require__(8995))));
},
"./PatientStats": () => {
return Promise.all(/*  | __federation_expose_PatientStats */ [__webpack_require__.e("168"), __webpack_require__.e("34"), __webpack_require__.e("434"), __webpack_require__.e("841")]).then(() => (() => (__webpack_require__(1646))));
},
"./AiUsageStats": () => {
return Promise.all(/*  | __federation_expose_AiUsageStats */ [__webpack_require__.e("168"), __webpack_require__.e("34"), __webpack_require__.e("685"), __webpack_require__.e("889")]).then(() => (() => (__webpack_require__(1010))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };